// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__zZBA9","header":"Messages_header__xVrvx"};